import {ItemSearch} from './ItemSearch';
import { SparePartCart } from './SparePartCart';

export class SparePartSearch extends ItemSearch {
  private viewPortWidth: number;
  private toggleMaxWidth: number;
  private toggleButtonSelector: string;
  private sparePartCart: any;

  constructor(elementId: string, ajaxEndpoint: string, resultTemplateSelector: string, resultContainerSelector: string){
    super(elementId, ajaxEndpoint, resultTemplateSelector, resultContainerSelector);

    this.toggleButtonSelector = '.toggle-cell';
    this.toggleMaxWidth =  1680;
    this.viewPortWidth = window.innerWidth;
    this.sparePartCart = new SparePartCart();


    window.onresize = () => this.onScreenResize();
  }

  /**
  * Process search results and add markup to the result element - extend parent class method
  * @param {object} data - data to be rendered in the template
  */
  public processSearchResults(data:any) {
    super.processSearchResults(data);

    if(data.items.length){
      //attach cart form hadlers
      this.sparePartCart.attachListeners();

      this.handleToggleVisibility();
      this.attachCellToggle();
    }

  }

  /**
  * Screen rezice events
  */
  private onScreenResize() {
    this.viewPortWidth = window.innerWidth;
    this.handleToggleVisibility();
  }

  //TOGGLE FUNCTIONALITY

  /**
   * Decide whether or not togglable content is visible
   */
  private handleToggleVisibility() {
    const button = this.resultContainer.querySelector(this.toggleButtonSelector);
    const targets = button ? Array.from(this.resultContainer.getElementsByClassName(button.getAttribute('data-target'))) : [];

    if(this.viewPortWidth < this.toggleMaxWidth) {
      this.hideContent(targets, button);
      button ? button.removeAttribute('disabled') : [];
    } else {
      this.showContent(targets, button);
      button ? button.setAttribute('disabled','disabled') : [];
    }
  }

  /**
   * Attach toggle functions to search results
   */
  private attachCellToggle() {
    this.resultContainer.querySelector(this.toggleButtonSelector).addEventListener('click', (e) => {
      const button = e.currentTarget as Element;
      const selector = button.getAttribute('data-target');
      const target = Array.from(this.resultContainer.getElementsByClassName(selector));
      this.toggleContent(target, button);
    });
  }

  /**
   * Toggle content visibility
   * @param targets content to be toggled
   * @param button button that controls the toggle
   */
  private toggleContent(targets:any, button:Element) {
    if(button['aria-expanded']) {
      this.hideContent(targets, button);
    } else {
      this.showContent(targets, button);
    }
  }

  /**
   * Hide content
   * @param target content to be toggled
   * @param button button that controls the toggle
   */
  private hideContent(targets:any, button:Element){
    targets.forEach(target => {
      target.style.display = 'none';
    });
    if (button) {
      button['aria-expanded'] = false;
    }
  }

  /**
   * Show content
   * @param target content to be toggled
   * @param button button that controls the toggle
   */
  private showContent(targets:any, button:Element){
    targets.forEach(target => {
      target.style.display = 'initial';
    });
    if (button) {
      button['aria-expanded'] = true;
    }
  }

}




